import { value } from '@takeshape/util';
import { createUserDefinedPaginationHelper } from "./config-utils.js";
import { paginationSchemes } from "./schemes.js";
export function detectPaginationScheme(projectSchema, propOrQuery) {
    return paginationSchemes.find((scheme) => scheme.predicate(projectSchema, propOrQuery));
}
export function getPaginationHelper(projectSchema, queryConfig, query, options) {
    const userDefinedPaginationHelper = createUserDefinedPaginationHelper(queryConfig, options);
    if (userDefinedPaginationHelper) {
        if (queryConfig.concurrency) {
            userDefinedPaginationHelper.concurrency = queryConfig.concurrency;
        }
        return userDefinedPaginationHelper;
    }
    // Non-paginated query (returns all data in one request)
    if (typeof query.shape === 'object' && query.shape.type === 'array' && !query.args) {
        return {
            getArgs: value(undefined),
            hasMore: value(false),
            itemsPath: '$',
            paginationType: 'offset',
            getState: () => ({
                type: 'offset',
                page: 1,
                itemsProcessed: 0,
                offset: 0,
                pageSize: undefined
            })
        };
    }
    const helper = detectPaginationScheme(projectSchema, query)?.createPaginationHelper(options);
    if (helper && queryConfig.concurrency) {
        helper.concurrency = queryConfig.concurrency;
    }
    return helper;
}
